/* eslint-disable */
//
// UTMB Web
//

//window.utmbWeb = window.utmbWeb || {}; // raise exception is window.utmbWeb does not exist - public/config.js
(function(config) {
    let utmbBody = document.body;
  
    function consoleLog() {
      if (config.useConsoleLog) {
        console.log(config);
      }
    }

    function removePreloader() {
      utmbBody.classList.remove("utmb-page-preloader");
    }
  
    function designMode() {
      config.designMode = config.designMode ? config.designMode : "classic";
      utmbBody.classList.add("design-mode-" + config.designMode);
    }
  
    function theme() {
      if (config.theme) {
        utmbBody.classList.add(config.theme);
      }
    }

    function exploreMenu() {
      if (config.useExploreMenu && config.exploreMenuTheme && config.exploreMenuTheme !== "exp-remove") {
        if (config.designMode === "classic") {
          config.exploreMenuTheme = "exp-mega";
        } else {
          config.navigateMenuTheme = "exp-main";
        }
        utmbBody.classList.add(config.exploreMenuTheme);
      }
    }
  
    function navigateMenu() {
      if (config.useNavigateMenu && config.navigateMenuTheme && config.navigateMenuTheme !== "nav-remove") {
        if (config.designMode === "classic") {
          config.navigateMenuTheme = config.navigateMenuTheme;
        } else {
          config.navigateMenuTheme = "nav-main";
        }
        utmbBody.classList.add(config.navigateMenuTheme);
      }
    }
  
    function init() {
      // Set body classes
      removePreloader()
      designMode();
      theme();
      exploreMenu();
      navigateMenu();
      consoleLog();
    }
  
    init();
  })(window.utmbWeb);